import { IObservable } from '~/rage/utils';
import { Gender, WalletType } from '~/shared';

export interface IClothesShopItem {
	/** Идентификатор предмета одежды */
	id: string;
	/** Название предмета одежды */
	name: string;
	/** Цена предмета одежды */
	price: number;
	/** Старая цена предмета одежды */
	oldPrice?: number;
	/** Скидка на предмет одежды */
	discount?: number;
	/** Валюта, за которую продается предмет */
	wallet: WalletType.Cash | WalletType.Donate;
	/** Категория предмета одежды */
	category: ClothesShopCategoryIndex;
	/**
	 * Родительский предмет одежды для группировки
	 * одинаковых предметов с разными цветами
	 */
	parentItemId: string | null;
	gender: Gender;
}

export enum ClothesShopCategoryIndex {
	TOP, // Верхняя одежда
	PANTS, // Штаны
	SHOES, // Обувь
	MASK, // Маски
	HAT, // Головные уборы
	GLASSES, // Очки
	BACKPACK, // Рюкзак
	ACCESSORIES, // Рюкзаки
	OUTFIT, // Костюмы
	EARS, // Серьги
	WATCHES, // Часы
	BRACELETS, // Браслеты
	ARMOR, // Броники
}

export interface IClothesShopService {
	/** Получить предметы в магазине */
	getShopItems(): IObservable<IClothesShopItem[]>;
	/** Получить предмет по id */
	getShopItemById(itemId: string): IClothesShopItem | null;
	/** Получить id предметов, которые надеты на персонажа */
	getWearingItems(): IObservable<string[]>;

	/** Показать предмет одежды на персонаже */
	previewItem(itemId: string): Promise<void>;
	/** Сбросить превью */
	clearPreview(): Promise<void>;

	/** Купить предмет одежды */
	buy(itemId: string, wallet: WalletType): Promise<void>;

	isUnseen(path: string): boolean;
	markSeen(path: string): void;

	/** Выйти из магазина */
	exitShop(): Promise<void>;
}
